import React from 'react';
import './spinner.css';

const Spinner = (props) => {
  return <div className="loader" {...props}></div>;
};
export default Spinner;
